import {z} from 'zod';

import {TitleExtensionLanguageSchema} from '@dms/api/sales';
import i18n from '@dms/i18n';

export const titleExtensionEquipmentDraftSchema = z.object({
  separator: z.string().min(1).max(10),
  items: z.array(
    z.object({
      featureKey: z.string().min(1),
      name: z.string(),
      shortNames: z.array(
        z.object({
          language: TitleExtensionLanguageSchema,
          shortName: z
            .string()
            .trim()
            .min(1, {message: i18n.t('general.errors.mixed.required')})
            .max(255),
        })
      ),
    })
  ),
});

export type TitleExtensionEquipmentFormValues = z.infer<typeof titleExtensionEquipmentDraftSchema>;
